import { IconButton } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { CopyButtonProps } from './CopyButton.types';
import CopyButtonStyles from './CopyButton.styles';

export const CopyButton = ({ label, value, t, onCopy }: CopyButtonProps) => (
  <IconButton
    data-testid={label}
    className="ml-2"
    onClick={() => onCopy(t(label), value)}
  >
    <ContentCopyIcon className={CopyButtonStyles.copyButton} />
  </IconButton>
);

export default CopyButton;
